import React from "react";
import { useFormContext } from "react-hook-form";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import Supplier from "../../../../utilities/data/model/Supplier";
import {
  Button,
  FlatActionList,
  FlatActionListItem,
  Page,
} from "@towersystems/roam-common-native";
import { StackScreenProps } from "@react-navigation/stack";
import colors from "react-native-ui-lib/src/style/colors";
import { Feather } from "@expo/vector-icons";
import {
  CreateProductRootParamList,
  EditProductRootParamList,
} from "../../../../types";

export type ProductSelectSupplierScreenProps = StackScreenProps<
  CreateProductRootParamList & EditProductRootParamList,
  "ProductSelectSupplierScreen"
>;

export const ProductSelectSupplierScreen = ({
  navigation,
}: ProductSelectSupplierScreenProps) => {
  const database = useDatabase();

  const [suppliers, setSuppliers] = React.useState<Supplier[] | undefined>();

  const { watch, setValue } = useFormContext<{
    supplierId: string;
  }>();

  const watchedSupplierId = watch("supplierId");

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: () =>
        !watchedSupplierId ? null : (
          <Button
            label="Remove Supplier"
            isAction
            onPress={() => {
              setValue("supplierId", "", {
                shouldValidate: true,
                shouldDirty: true,
              });
              navigation.goBack();
            }}
            size="compact"
          ></Button>
        ),
    });
  }, [setValue, watchedSupplierId]);

  React.useEffect(() => {
    database
      .get<Supplier>("suppliers")
      .query()
      .fetch()
      .then((l) => setSuppliers(l));
  }, []);

  const handleOnSelect = React.useCallback((supplierId: string) => {
    setValue("supplierId", supplierId, {
      shouldValidate: true,
      shouldDirty: true,
    });
    navigation.goBack();
  }, []);

  const items: FlatActionListItem[] = React.useMemo(() => {
    return (
      suppliers?.map((supplier) => {
        return {
          key: supplier.id,
          title: supplier.name,
          onPress: () => handleOnSelect(supplier.id),
          disabled: watchedSupplierId == supplier.id,
          componentRight: (icon) => {
            return watchedSupplierId == supplier.id ? (
              <Feather name="check" size={24} color={colors.primary} />
            ) : (
              icon
            );
          },
        };
      }) || []
    );
  }, [suppliers, watchedSupplierId, handleOnSelect]);

  return (
    <Page title="Select Supplier">
      <FlatActionList items={items} />
    </Page>
  );
};
